/* ============================================
   RETRO GAMING STICK THEME - JAVASCRIPT
   ============================================ */

// Document Ready
document.addEventListener('DOMContentLoaded', function() {
  initTheme();
  initCart();
  initProductGallery();
  initQuantityControls();
  initNewsletterForm();
  addRetroEffects();
});

// Initialize Theme
function initTheme() {
  console.log('🎮 RETRO GAMING THEME LOADED');

  // Add entrance animations to sections
  const sections = document.querySelectorAll('.section');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('entrance-fade');
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(section => {
    observer.observe(section);
  });
}

// Cart Functionality
function initCart() {
  // Add to cart form handling
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.innerHTML;

      // Button loading state
      button.disabled = true;
      button.innerHTML = '<span class="pixel-font">ADDING...</span>';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        const data = await response.json();

        if (response.ok) {
          // Success animation
          button.innerHTML = '<span class="pixel-font">ADDED! ✓</span>';
          button.style.background = 'var(--color-success)';

          // Update cart count
          updateCartCount();

          // Show success message
          showRetroNotification('ITEM ADDED TO CART!', 'success');

          // Reset button after delay
          setTimeout(() => {
            button.innerHTML = originalText;
            button.disabled = false;
            button.style.background = '';
          }, 2000);
        } else {
          throw new Error(data.description || 'Failed to add item');
        }
      } catch (error) {
        button.innerHTML = '<span class="pixel-font">ERROR ✗</span>';
        button.style.background = 'var(--color-error)';
        showRetroNotification('FAILED TO ADD ITEM', 'error');

        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
          button.style.background = '';
        }, 2000);
      }
    });
  });
}

// Update Cart Count
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const cartLinks = document.querySelectorAll('.cart-link');
    cartLinks.forEach(link => {
      link.innerHTML = `<span class="pixel-font">CART (${cart.item_count})</span>`;
    });
  } catch (error) {
    console.error('Failed to update cart count:', error);
  }
}

// Product Gallery
function initProductGallery() {
  const thumbnails = document.querySelectorAll('.thumbnail');

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      // Remove active class from all thumbnails
      thumbnails.forEach(t => t.classList.remove('active'));

      // Add active class to clicked thumbnail
      this.classList.add('active');

      // Add retro click effect
      this.style.animation = 'shake-8bit 0.3s ease';
      setTimeout(() => {
        this.style.animation = '';
      }, 300);
    });
  });
}

// Quantity Controls
function initQuantityControls() {
  // These functions are also defined inline in product.liquid for compatibility
  // but we can enhance them here

  const qtyInputs = document.querySelectorAll('.qty-input');

  qtyInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.value < 1) {
        this.value = 1;
      }

      // Add pixel shake effect on change
      this.style.animation = 'shake-8bit 0.3s ease';
      setTimeout(() => {
        this.style.animation = '';
      }, 300);
    });
  });
}

// Increment Quantity
window.incrementQty = function() {
  const input = document.getElementById('quantity');
  if (input) {
    input.value = parseInt(input.value) + 1;
    playRetroSound('increment');
  }
};

// Decrement Quantity
window.decrementQty = function() {
  const input = document.getElementById('quantity');
  if (input && parseInt(input.value) > 1) {
    input.value = parseInt(input.value) - 1;
    playRetroSound('decrement');
  }
};

// Newsletter Form
function initNewsletterForm() {
  const newsletterForms = document.querySelectorAll('.newsletter-form');

  newsletterForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const email = this.querySelector('input[type="email"]').value;
      const button = this.querySelector('button[type="submit"]');
      const originalText = button.textContent;

      button.textContent = 'SENDING...';
      button.disabled = true;

      // Simulate form submission (replace with actual endpoint)
      setTimeout(() => {
        button.textContent = 'SUBSCRIBED!';
        showRetroNotification('NEWSLETTER SIGNUP COMPLETE!', 'success');

        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          this.reset();
        }, 2000);
      }, 1000);
    });
  });
}

// Retro Notification System
function showRetroNotification(message, type = 'info') {
  // Remove existing notification if any
  const existing = document.querySelector('.retro-notification');
  if (existing) {
    existing.remove();
  }

  // Create notification element
  const notification = document.createElement('div');
  notification.className = 'retro-notification';
  notification.innerHTML = `
    <div class="notification-content pixel-font">
      ${type === 'success' ? '✓' : type === 'error' ? '✗' : 'ℹ'} ${message}
    </div>
  `;

  // Style based on type
  const colors = {
    success: 'var(--color-success)',
    error: 'var(--color-error)',
    info: 'var(--color-secondary)'
  };

  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: var(--color-surface);
    border: 3px solid ${colors[type]};
    padding: 16px 24px;
    z-index: 10000;
    box-shadow: 0 0 20px ${colors[type]};
    animation: slide-in-right 0.3s ease, pixel-pulse 0.5s ease;
  `;

  document.body.appendChild(notification);

  // Play sound effect
  playRetroSound(type);

  // Auto remove after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'slide-in-right 0.3s ease reverse';
    setTimeout(() => {
      notification.remove();
    }, 300);
  }, 3000);
}

// Retro Sound Effects (Web Audio API)
function playRetroSound(type) {
  if (!window.AudioContext && !window.webkitAudioContext) {
    return; // Browser doesn't support Web Audio API
  }

  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  // Different sounds for different actions
  const sounds = {
    success: { frequency: 800, duration: 0.1, type: 'sine' },
    error: { frequency: 200, duration: 0.2, type: 'sawtooth' },
    increment: { frequency: 600, duration: 0.05, type: 'square' },
    decrement: { frequency: 400, duration: 0.05, type: 'square' },
    click: { frequency: 500, duration: 0.05, type: 'sine' }
  };

  const sound = sounds[type] || sounds.click;

  oscillator.frequency.value = sound.frequency;
  oscillator.type = sound.type;

  gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + sound.duration);

  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + sound.duration);
}

// Add Retro Effects
function addRetroEffects() {
  // Add hover sound to buttons
  const buttons = document.querySelectorAll('.btn-retro, .btn-pixel, .nav-link');

  buttons.forEach(button => {
    button.addEventListener('mouseenter', function() {
      // Subtle hover effect
      this.style.transform = 'scale(1.02)';
    });

    button.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });

    button.addEventListener('click', function() {
      playRetroSound('click');
      this.style.animation = 'button-press 0.2s ease';
      setTimeout(() => {
        this.style.animation = '';
      }, 200);
    });
  });

  // Add parallax effect to hero section
  const hero = document.querySelector('.hero-banner');
  if (hero) {
    window.addEventListener('scroll', function() {
      const scrolled = window.pageYOffset;
      hero.style.transform = `translateY(${scrolled * 0.3}px)`;
    });
  }

  // Add Easter egg - Konami code
  let konamiCode = [];
  const konamiPattern = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];

  document.addEventListener('keydown', function(e) {
    konamiCode.push(e.key);
    konamiCode = konamiCode.slice(-10);

    if (konamiCode.join(',') === konamiPattern.join(',')) {
      activateKonamiMode();
    }
  });
}

// Konami Code Easter Egg
function activateKonamiMode() {
  showRetroNotification('🎮 KONAMI CODE ACTIVATED! 🎮', 'success');

  // Add rainbow effect to page
  document.body.style.animation = 'color-cycle 2s linear infinite';

  // Play victory sound sequence
  setTimeout(() => playRetroSound('success'), 0);
  setTimeout(() => playRetroSound('success'), 100);
  setTimeout(() => playRetroSound('success'), 200);

  // Revert after 5 seconds
  setTimeout(() => {
    document.body.style.animation = '';
    showRetroNotification('NORMAL MODE RESTORED', 'info');
  }, 5000);
}

// Variant Selector Change
const variantSelectors = document.querySelectorAll('.variant-select');
variantSelectors.forEach(select => {
  select.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    playRetroSound('click');
  });
});

// Smooth Scroll for Anchor Links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    if (href !== '#' && document.querySelector(href)) {
      e.preventDefault();

      const target = document.querySelector(href);
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// FAQ Toggle Functions (also defined inline for compatibility)
window.toggleFaq = function(button) {
  const faqItem = button.parentElement;
  const answer = faqItem.querySelector('.faq-answer');
  const icon = button.querySelector('.faq-icon');

  faqItem.classList.toggle('active');
  playRetroSound('click');

  if (faqItem.classList.contains('active')) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    icon.textContent = '▼';
  } else {
    answer.style.maxHeight = '0';
    icon.textContent = '▶';
  }
};

window.toggleProductFaq = window.toggleFaq;

// Product Image Change
window.changeImage = function(src) {
  const mainImage = document.getElementById('mainImage');
  if (mainImage) {
    mainImage.src = src;
    mainImage.style.animation = 'pixel-fade-in 0.3s ease';
    setTimeout(() => {
      mainImage.style.animation = '';
    }, 300);
  }

  const videos = document.querySelectorAll('.product-video');
  videos.forEach(v => v.style.display = 'none');

  playRetroSound('click');
};

// Show Product Video
window.showVideo = function(id) {
  const mainImage = document.getElementById('mainImage');
  if (mainImage) {
    mainImage.style.display = 'none';
  }

  const videos = document.querySelectorAll('.product-video');
  videos.forEach(v => v.style.display = 'none');

  const video = document.getElementById('video-' + id);
  if (video) {
    video.style.display = 'block';
    video.style.animation = 'pixel-fade-in 0.3s ease';
  }

  playRetroSound('click');
};

// Console Easter Egg
console.log('%c🎮 RETRO GAMING STICK THEME 🎮', 'color: #FF006E; font-size: 20px; font-weight: bold;');
console.log('%cPowered by Shopify | Built with 80s Nostalgia', 'color: #00F5FF; font-size: 12px;');
console.log('%cTry the Konami Code: ↑ ↑ ↓ ↓ ← → ← → B A', 'color: #FFBE0B; font-size: 10px;');

// Export functions for global use
window.RetroTheme = {
  showNotification: showRetroNotification,
  playSound: playRetroSound,
  updateCartCount: updateCartCount
};
